import React, { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import BasicSlideToggle from '../../../../../../components/BasicSlideToggle';
import TooltipIcon from '../../../../../../components/TooltipIcon';

const ActiveSlideToggle = props => {
  const { name, values, hasActiveReq, text, onChange } = props;

  useEffect(() => {
    if (values.Active && !hasActiveReq) {
      handleOnChange(name, false);
    }
  }, [hasActiveReq]);

  const isDisabled = useMemo(
    () =>
      !(
        hasActiveReq &&
        values.Subject &&
        values.Message.getCurrentContent().hasText() &&
        values.RecruiterID
      ),
    [values, hasActiveReq]
  );

  const handleOnChange = (field, values) => {
    onChange(field, values);
  };

  return (
    <div className="setup-email__toggle">
      <BasicSlideToggle
        name={name}
        label={values.Active ? 'Active' : 'Inactive'}
        checked={values.Active}
        onChange={handleOnChange}
        disabled={isDisabled}
      />
      <div className="setup-email__tooltip">
        <TooltipIcon
          content={text}
          type="question"
          contentStyle={{
            minWidth: '232px',
          }}
        />
      </div>
    </div>
  );
};

ActiveSlideToggle.propTypes = {
  name: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired,
  hasActiveReq: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ActiveSlideToggle;
